import { useEffect } from 'react'

import { CombinedLogs, useGetControllerLogs, useGetMileagePeriod, useGetUnfinishedLogs } from '@/modules/CombinedLogs'
import { Loader } from '@/ui/Loader'
import { WorkstationPM } from '@/modules/Workstation'
import { Mileage } from '@/modules/Mileage'
import { useInitPMSession } from '../hooks/useInitPMSession'
import { useWorkstationStore } from '@/modules/Workstation/store'

import commonStyles from './Dashboard.module.scss'
import { useGetHubs } from '@/modules/Workstation/api/useGetHubs'

export const PerformanceManagerDashboard = () => {
    const init = useInitPMSession()
    const { isPending: isMileagePeriodPending } = useGetMileagePeriod()
    const { isPending: isLoadingHubs } = useGetHubs()
    const { isPending: isLoadingUnfinishedLogs } = useGetUnfinishedLogs()
    const { isPending: isLoadingControllerLogs } = useGetControllerLogs({ useAreaRoutes: true })
    const { routes } = useWorkstationStore()

    useEffect(() => {
        init()
    }, [])

    if (isMileagePeriodPending || isLoadingHubs || isLoadingUnfinishedLogs || isLoadingControllerLogs) {
        return (
            <section className={commonStyles.root}>
                <Loader />
            </section>
        )
    }

    return (
        <section className={commonStyles.root}>
            <div className={commonStyles.header}>
                <WorkstationPM />
                <Mileage displayed={!!routes.length} />
            </div>

            <CombinedLogs />
        </section>
    )
}
